"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ViewContainer = require("./ViewContainer");
Object.keys(_ViewContainer).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ViewContainer[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ViewContainer[key];
    }
  });
});